import { __assign } from "tslib";
import * as React from "react";
var SvgTomIconRemove = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, fill: "none", viewBox: "0 0 24 25" }, props),
    React.createElement("path", { fill: "currentColor", d: "M19 13.588H5v-2h14z" }))); };
export default SvgTomIconRemove;
//# sourceMappingURL=TomIconRemove.js.map